// extracted by mini-css-extract-plugin
export default {"label":"WordScript_label__uZKtV","script":"WordScript_script__bt1Cf"};